module.exports = __webpack_public_path__ + "ada4458b361d5e72bcbd19da105afdc5.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Hairline.woff2
// module id = 956
// module chunks = 0